import axios from "axios";
import Vue from "vue";
import {api} from "@/store/api";
import router from "@/router";

export default {
  state: {
    is_server_req: false,
    show_modal_programari: false,
    is_delete_req: false,
    appointments_type: [
      'Consultație'
    ],
    appointmentData: Generate_Appointment(),
    send_feedback_after_treatment: null,
  },
  mutations: {
    SET_CALENDAR_STATE (state, { key, value }) {
      Vue.set(state, key, value);
    },
    ADD_APPOINTMENT_DATA (state, { key, value }) {
      Vue.set(state.appointmentData, key, value);
    },
    SET_SHOW_MODAL_PROGRAMARI (state, value) {
      Vue.set(state, 'show_modal_programari', value);
    },
    UPDATE_APPOINTMENT_DATA (state, { key, value }) {
      Vue.set(state.appointmentData, key, value);
    },
    RESET_APPOINTMENT_DATA (state) {
      Vue.set(state, 'appointmentData', Generate_Appointment());
    },
    SET_APPOINTMENT_DATA (state, data) {
      state.appointmentData = data;
    },
    SET_WAPP_FEEDBACK_STATE (state, payload) {
      state.send_feedback_after_treatment = payload
    }
  },
  actions: {
    async create_appointment_icalendar ({ state, commit, rootState }) {
      try {
        commit('SET_CALENDAR_STATE', { key: 'is_server_req', value: true });
        const patient_id = router.currentRoute.params.id;
        const {prenume, nume, telefon, phoneCountry } = rootState.pacient;
        let payload = {
          ...state.appointmentData,
          created_at: new Date().toISOString()
        }
        if (patient_id) {
          payload = {
            ...payload,
            patient_name: `${nume}`,
            patient_surname: `${prenume}`,
            patient_id,
            patient_phone: phoneCountry
              ? `${phoneCountry?.dialCode}${telefon.startsWith('0') ? telefon.slice(1) : telefon }`
              : `40${telefon.startsWith('0') ? telefon.slice(1) : telefon }`
          }
        }
        const { data } = await axios.post(api.create_appointment, payload);
        commit('SET_CALENDAR_STATE', { key: 'is_server_req', value: false });
        commit('RESET_APPOINTMENT_DATA');
        commit('SET_SHOW_MODAL_PROGRAMARI', false);
        commit('ADD_APPOINTMENT_TO_PATIENT', data);
      }
      catch (err) {
        console.log(err);
        commit('SET_CALENDAR_STATE', { key: 'is_server_req', value: false });
      }
    },
    async update_appointment_icalendar ({state, commit}) {
      try {
        commit('SET_CALENDAR_STATE', { key: 'is_server_req', value: true });
        const patient_id = router.currentRoute.params.id;
        const url = `${api.update_appointment}/${patient_id}`;
        const { data } = await axios.put(url, state.appointmentData);
        commit('SET_CALENDAR_STATE', { key: 'is_server_req', value: false });
        commit('RESET_APPOINTMENT_DATA');
        commit('SET_SHOW_MODAL_PROGRAMARI', false);
        commit('UPDATE_APPOINTMENT_IN_PATIENT', data);
      }
      catch (err) {
        console.log(err);
        commit('SET_CALENDAR_STATE', { key: 'is_server_req', value: false });
      }
    },
    async delete_appointment_icalendar ({state, commit}) {
      try {
        commit('SET_CALENDAR_STATE', { key: 'is_delete_req', value: true });
        const patient_id = router.currentRoute.params.id;
        const appointment_id = state.appointmentData._id;
        const url = `${api.delete_appointment}/${patient_id}/${appointment_id}`;
        await axios.delete(url);
        commit('SET_CALENDAR_STATE', { key: 'is_delete_req', value: false });
        commit('RESET_APPOINTMENT_DATA');
        commit('SET_SHOW_MODAL_PROGRAMARI', false);
        commit('DELETE_APPOINTMENT_IN_PATIENT', appointment_id);
      }
      catch (err) {
        console.log(err);
        commit('SET_CALENDAR_STATE', { key: 'is_delete_req', value: false });
      }
    },
  }
}


function Generate_Appointment () {
  return {
    date: new Date(),
    hour: 8,
    minute: 0,
    duration_hour: 0,
    duration_minute: 0,
    type: '',
    doctor: '',
    template: 'Notificare programare',
    patient_name: '',
    patient_surname: '',
    patient_phone: '',
    lang: 'RO',
  };
}
